import { render, staticRenderFns } from "./AgendaField.vue?vue&type=template&id=239f83d0&scoped=true&"
import script from "./AgendaField.vue?vue&type=script&lang=ts&"
export * from "./AgendaField.vue?vue&type=script&lang=ts&"
import style0 from "./AgendaField.vue?vue&type=style&index=0&id=239f83d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239f83d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VMenu,VTextField})
